module.exports = __webpack_public_path__ + "static/media/IM.3de31e6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IM.svg
// module id = 277
// module chunks = 0